jQuery(function($){
  $('.call-cta__button').on('click', function(){
    $('.call-cta__arrow, .call-cta__content').toggleClass('m--active');
    $(this).toggleClass('m--active');
  });
});
